<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <!-- 絞り込み設定 -->
    <transition name="popup">
      <SPInformationSearchExtract
        v-if="state.visibleInformationExtract"
        :parentData="data"
        @closeInformationExtract="state.visibleInformationExtract = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        @click="state.visibleInformationExtract = true"
        >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>お知らせ</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row">
              <div class="navi-arrow prev"
                v-if="state.numberCarouselVisible !== 0"
                @click="onClickPrev"
              >
                <FontawesomeIcon :icon="['far','angle-left']" size="sm" class="icn" />
              </div>
              <ul class="navi-list">
                <li class="navi-list-item"
                  :class="{'is-active': state.numberCarouselVisible === 0}"
                  id="navigation_0"
                >
                  <button @click="onCategorySelected(0, 0)" 
                    class="navi-list-item-label">すべて</button>
                </li>
                <li v-for="(category, index) in data.categories" :key="'category_' + index"
                   class="navi-list-item"
                  :class="{'is-active': state.numberCarouselVisible === (index + 1)}"
                  :id="'navigation_' + (index + 1)"
                 >
                  <button @click="onCategorySelected(category.code, index + 1)"
                    class="navi-list-item-label">{{category.value1}}</button>
                </li>
              </ul>
              <div class="navi-arrow next"
                v-if="state.numberCarouselVisible + 1 !== state.numberCarouselLength"
                @click="onClickNext"
              >
                <FontawesomeIcon :icon="['far','angle-right']" size="sm" class="icn" />
              </div>
            </div>
          </div>
          <div class="main-container">
            <Carousel
              ref="carousel"
              :perPage="1"
              :speed="200"
              :minSwipeDistance="100"
              :navigateTo="state.numberCarouselVisible"
              :navigationEnabled="false"
              :paginationEnabled="false"
              @pageChange="onPageChange"
              :touchDrag="false"
              :mouseDrag="false"
            >
              <!-- すべて -->            
              <Slide :id="getSlideId(0)">
                <div v-if="!state.isListsLoaded || state.numberCarouselVisible !== 0 || (state.isListsLoaded && data.count === null)" style="padding-top: 50%;">
                  <FontawesomeIcon
                    :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" style="height: 100%;" />
                </div>
                <template v-else>
                  <div class="result">
                    <p v-if="data.count !== null && data.count !== 0" class="result-num">{{data.count}}件</p>
                    <p v-else-if="data.canload" class="result-num">0件</p>
                  </div>
                  <template v-if="data.count > 0">
                    <template v-for="(dateLists, index) in data.lists_sp">
                      <div :key="'publication_day_' + index" class="date">
                        {{ formatDate(dateLists.publication_day) }}
                      </div>
                      <ul :key="'lists_' + index" class="list-result list-result-02">
                        <li v-for="(list, index2) in dateLists.lists" :key="'lists2_' + index2" class="list-result-item">
                          <div class="list-result-item-main">
                            <div class="list-result-title">
                              <span v-if="list.type === 1" class="no-link">{{list.title}}</span>
                              <a v-else-if="list.type === 2" v-bind:href="list.url" target="_blank">{{list.title}}<FontawesomeIcon :icon="['far','external-link']" class="icn" /></a>
                              <a v-else-if="list.type === 3" @click="action.routeList(list)" role="button">{{list.title}}</a>
                              <span v-if="list.classification === 3 || list.classification === 2"
                                class="icon-label" :class="list.classification === 3 ? 'red' : 'gray'"
                              >{{ list.classification_name }}</span>
                              </div>
                            <p class="list-result-description">{{ list.summary }}</p>
                            <div class="list-result-category">
                              <ul>
                                <li>{{ list.category_name }}</li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </template>
                    <SPPagenation
                      v-if="data.isPaginationShown"
                      :count="news.pagenation.count"
                      :per_page="news.search.per_page"
                      :currentPage="news.pagenation.currentPage"
                      @changePage="clickPageNation"
                    />
                  </template>
                  <template v-else-if="data.canload">
                    <ul class="list-result list-result-02">
                      <li class="list-result-item">
                        表示する内容がありません。
                      </li>
                    </ul>
                  </template>

                </template>
              </Slide>
              <!-- カテゴリ -->            
              <template v-for="(category, index0) in data.categories">
                <Slide :id="getSlideId(index0 + 1)" :key="'slide_' + index0">
                  <div v-if="!state.isListsLoaded || state.numberCarouselVisible !== (index0 + 1)" style="padding-top: 50%;">
                    <FontawesomeIcon 
                      :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" style="height: 100%;" />
                  </div>
                  <template v-else>
                    <div class="result">
                      <p v-if="data.count !== null && data.count !== 0" class="result-num">{{data.count}}件</p>
                      <p v-else-if="data.canload" class="result-num">0件</p>
                    </div>
                    <template v-if="data.count > 0">
                      <template v-for="(dateLists, index) in data.lists_sp">
                        <div :key="'publication_day_' + index" class="date">
                          {{ formatDate(dateLists.publication_day) }}
                        </div>
                        <ul :key="'lists_' + index" class="list-result list-result-02">
                          <li v-for="(list, index2) in dateLists.lists" :key="'lists2_' + index2" class="list-result-item">
                            <div class="list-result-item-main">
                              <div class="list-result-title">
                                <span v-if="list.type === 1" class="no-link">{{list.title}}</span>
                                <a v-else-if="list.type === 2" v-bind:href="list.url" target="_blank">{{list.title}}<FontawesomeIcon :icon="['far','external-link']" class="icn" /></a>
                                <a v-else-if="list.type === 3" @click="action.routeList(list)" role="button">{{list.title}}</a>
                                <span v-if="list.classification === 3 || list.classification === 2"
                                  class="icon-label" :class="list.classification === 3 ? 'red' : 'gray'"
                                >{{ list.classification_name }}</span>
                                </div>
                              <p class="list-result-description">{{ list.summary }}</p>
                              <div class="list-result-category">
                                <ul>
                                  <li>{{ list.category_name }}</li>
                                </ul>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </template>
                      <SPPagenation
                        v-if="data.isPaginationShown"
                        :count="news.pagenation.count"
                        :per_page="news.search.per_page"
                        :currentPage="news.pagenation.currentPage"
                        @changePage="clickPageNation"
                      />
                    </template>
                    <template v-else-if="data.canload">
                      <ul class="list-result list-result-02">
                        <li class="list-result-item">
                          表示する内容がありません。
                        </li>
                      </ul>
                    </template>

                  </template>
                </Slide>
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed, watch } from '@vue/composition-api'
import { InformationList } from '@/logic/information/InformationList'

import { Carousel, Slide } from 'vue-carousel'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPInformationSearchExtract from '@/components/sp/popup/SPInformationSearchExtract.vue'
import SPPagenation from '@/components/sp/partial/SPPagenation.vue'

export default defineComponent({
  components: {
    SPMenu,
    SPInformationSearchExtract,
    Carousel,
    Slide,
    SPPagenation
  },
  setup (props, context) {
    return { ...InformationList(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  padding-right: 82px;
  &-select {
    padding-left: 10px;
    .formparts.select {
      .select-label {
        color: #fff;
        font-size: 1.2rem;
        height: 36px;
        width: 136px;
        border-color: rgba(255,255,255,.2);
        .icn {
          color: #fff;
        }
      }
    }
  }
}
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    .result-num {
      padding: 28px 20px;
      background-color: #fff;
      border-bottom: 1px solid $color-line;
      color: $color-content;
      font-weight: bold;
      font-size: 1.4rem;
    }
  }
  &-heading {
    position: relative;
    .navi-list {
      margin: 0 40px;
      overflow-x: auto;
      white-space: nowrap;
      &-item {
        display: inline-block;
        position: relative;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 100%;
          background-color: $color-yellow;
          opacity: 0;
          transition: all .2s ease;
        }
        &-label {
          display: block;
          font-size: 1.6rem;
          color: $color-sup;
          font-weight: bold;
          padding: 20px 10px;
        }
        &.is-active {
          &:after {
            opacity: 1;
          }
          .navi-list-item-label {
            color: $color-link;
          }
        }
      }
    }
    .navi-arrow {
      position: absolute;
      top: 50%;
      transform: translate3d(0,-55%,0);
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      .icn {
        color: $color-link;
      }
      &.next {
        right: 0;
        border-left: 1px solid $color-line;
      }
      &.prev {
        left: 0;
        border-right: 1px solid $color-line;
      }
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
  }
}

.main {
  &-container {
    background-color: $color-bg-paper;
    .date {
      font-size: 1.4rem;
      color: $color-content;
      padding: 28px 20px;
    }
    .list-result {
      background-color: #fff;
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}
.main-heading-delete{
  text-align: right;
}
.main-heading-delete button{
  color: #005BAC;
}
.list-result-02 .list-result-item-menu .fa-times{
  font-size: 12px;
  color: #3E3E3E;
}
.list-result-state{
  font-size: 14px;
  font-weight: normal;
  color: #999;
}
.list-result-title{
  padding-right: 0;
  color: #ccc;
}
.list-result-state + .list-result-title{
  margin-top: 13px;
}
.list-result-text,
.list-result-category,
.list-result-author,
.list-result-date{
  ul{
    li{
      list-style: none;
      font-size: 14px;
      color: #999999;
    }
  }
}
.list-result-text,
.list-result-category,
.list-result-date{
  margin-top: 15px;
  ul{
    letter-spacing: -0.4em;
    li{
      display: inline-block;
      letter-spacing: normal;
      margin-right: 15px;
    }
  }
}
.list-result-author{
  margin-top: 1px;
  min-height: 40px;
  line-height: 40px;
  ul{
    li{
      img{
        vertical-align: middle;
        margin-left: 10px;
      }
    }
  }
}
.list-result-author + .list-result-text,
.list-result-author + .list-result-category{
  margin-top: 0;
}
.list-result-description{
  font-size: 14px;
  color: #555555;
}

</style>
